module.exports = __webpack_public_path__ + "img/qtouchNew.6ad6f4bd.png";